import type { ICellRendererParams } from 'ag-grid-community'

import { ControlImpact, getImpactFromWeight } from '@/lib/risk/control-impact'

type RowWithWeight = { controlWeight?: number }

export function ControlWeightCell<T extends RowWithWeight>(params: ICellRendererParams<T>) {
  if (!params.data) return null

  const weight = params.data.controlWeight
  if (weight === undefined || weight === null) return null

  const impact = getImpactFromWeight(weight)
  const isCritical = impact === ControlImpact.CRITICAL

  return (
    <div className='flex w-10 items-center justify-center'>
      <span className={isCritical ? 'text-main-foreground-danger' : 'text-main-foreground-primary'}>
        {weight}
      </span>
    </div>
  )
}
